module.exports = __webpack_public_path__ + "img/pfefferkorn-ingenieure.14744c0fdf3defd1b4d07f886b17e1ac.svg";